import React, { Suspense, useContext } from "react";
import RoleBasedRoute from "./RoleBasedRoute";

/**Constants**/
import { USER_ROLES } from "../utils/constants/userConstants";
import { UserContext } from "./MainLayout";

/**Third Party Components**/
import PropTypes from "prop-types";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

/**Components**/
import Dashboard from "../pages/dashboard/Dashboard";
import DeviceView from "../pages/deviceView/DeviceView";
import EventsNotification from "../pages/eventsNotification/EventsNotification";
import Help from "../pages/help/Help";
import LocationDashboard from "../pages/locationDashboard/locationDashboard";
import ReportDetails from "../pages/reports/ReportDetails";
import ReportDownloads from "../pages/reports/ReportDownloads";
import DeviceDiagnoParameterReport from "../pages/reports/Reports/DeviceDiagnoParameterReport";
import SummaryDetailsReport from "../pages/reports/Reports/SummaryDetailsReport";
import ReportsDashboard from "../pages/reports/ReportsDashboard";
import SchedulesDashboard from "../pages/schedules/SchedulesDashboard";
import SitesDashboard from "../pages/sitesDashboard/SitesDashboard";
import UserList from "../pages/userManagement/UserList";
import NotFound from "./NotFound";
import DeviceUpdateList from "../pages/reports/Reports/DeviceUpdateList";
import ServiceTool from "../pages/serviceTool/ServiceTool";
import { isServiceToolShow } from "../utils/constants/serviceToolConstant";

const AppRoutes = ({ globalDeviceDetails, globalLocationDetails, deviceQueryCount }) => {
  const { loggedInUserRole, featureEnabledStatus } = useContext(UserContext);

  // Component for Restricted Route beacuse we need it only for DEV start
  const IsServiceTool = () => {
    return isServiceToolShow() ? (
      <Outlet />
    ) : (
      <Navigate to="/" />
    );
  };
  // Component for Restricted Route beacuse we need it only for DEV end
  
  return (
    <Suspense>
      <Routes>
        {/* Routes for All User Access Starts */}
        <Route
          exact
          path="/"
          element={
            <Dashboard
              globalDeviceDetails={globalDeviceDetails}
              globalLocationDetails={globalLocationDetails}
              deviceQueryCount={deviceQueryCount}
            />
          }
        />
        <Route path="/device-view" element={<DeviceView />} />
        <Route path="/device-view/:id" element={<DeviceView />} />
        <Route exact path="/help" element={<Help />} />

        <Route path="/reports" element={<ReportsDashboard />} />
        <Route path="/reports/downloads" element={<ReportDownloads />} />
        <Route
          path="/reports/summary-details"
          element={<SummaryDetailsReport />}
        />
        <Route
          path="/reports/device-diagnostics"
          element={<DeviceDiagnoParameterReport />}
        />
        <Route
          path="/reports/device-parameters"
          element={<DeviceDiagnoParameterReport />}
        />
         <Route
          path="/reports/device-update-list"
          element={<DeviceUpdateList />}
        />

        <Route
          path="/events-and-notifications"
          element={<EventsNotification />}
        />
        <Route
          path="/events-and-notifications/:deviceId"
          element={<EventsNotification />}
        />
        {/* Routes for All User Access Ends */}

        {/* Restricted Routes based on User Roles [Corp SuperAdmin and Corp Admins] Starts */}
        <Route
          element={
            <RoleBasedRoute
              allowedRoles={[USER_ROLES.superAdminCorp, USER_ROLES.adminCorp]}
              currentUserRole={loggedInUserRole}
            />
          }
        >
          <Route
            path="/location-dashboard"
            element={<LocationDashboard />}
          ></Route>
          {featureEnabledStatus.scheduler && (
            <Route path="/schedules" element={<SchedulesDashboard />} />
          )}
          <Route path="/user-management" element={<UserList />} />
          <Route path="/reports/audit-trail" element={<ReportDetails />} />

          {/* Restricted Route beacuse we need it only for DEV start*/}
          <Route element={<IsServiceTool />}>
            <Route path="/service-tool" element={<ServiceTool />} />
          </Route>
          {/* Restricted Route beacuse we need it only for DEV end*/}
        </Route>
        {/* Restricted Routes based on User Roles [Corp SuperAdmin and Corp Admins] Ends */}

        {/* Restricted Routes based on User Roles [Corp SuperAdmin] Starts */}
        <Route
          element={
            <RoleBasedRoute
              allowedRoles={[USER_ROLES.superAdminCorp]}
              currentUserRole={loggedInUserRole}
            />
          }
        >
          <Route path="/sites-dashboard" element={<SitesDashboard />} />
        </Route>
        {/* Restricted Routes based on User Roles [Corp SuperAdmin] Ends */}

        <Route exact path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;

AppRoutes.propTypes = {
  globalDeviceDetails: PropTypes.object,
  globalLocationDetails: PropTypes.object,
};
